var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserAction2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "#DCFCE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 27.8369C31.4559 28.5683 32.7042 29.742 33.6153 31.2096C33.7957 31.5003 33.8859 31.6456 33.9171 31.8468C33.9805 32.2558 33.7008 32.7585 33.32 32.9204C33.1325 33 32.9217 33 32.5 33M28 23.5322C29.4817 22.7959 30.5 21.2669 30.5 19.5C30.5 17.7331 29.4817 16.2041 28 15.4678M26 19.5C26 21.9853 23.9853 24 21.5 24C19.0147 24 17 21.9853 17 19.5C17 17.0147 19.0147 15 21.5 15C23.9853 15 26 17.0147 26 19.5ZM14.5593 30.9383C16.1536 28.5446 18.6694 27 21.5 27C24.3306 27 26.8465 28.5446 28.4408 30.9383C28.7901 31.4628 28.9647 31.725 28.9446 32.0599C28.9289 32.3207 28.758 32.64 28.5496 32.7976C28.2819 33 27.9138 33 27.1777 33H15.8224C15.0862 33 14.7181 33 14.4505 32.7976C14.2421 32.64 14.0711 32.3207 14.0555 32.0599C14.0353 31.725 14.21 31.4628 14.5593 30.9383Z",
    stroke: "#166534",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAction2);
export default __webpack_public_path__ + "static/media/userAction2.4b19f5f6df2702b1cb629eb1ec1de452.svg";
export { ForwardRef as ReactComponent };